import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  standalone: true,
  selector: 'app-deployment-comment',
  templateUrl: './deployment-comment.component.html',
  styleUrl: './deployment-comment.component.scss',
  imports: [CommonModule]
})
export class DeploymentCommentComponent {
  title: string = "";
  popupcontent: SafeHtml;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer
  ) { }



  ngOnInit() {
    this.title = this.data.title;
    this.popupcontent = this.sanitizer.bypassSecurityTrustHtml(this.data.popupcontent); //NOSONAR
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
